import ReportedContentScreen from './ReportedContentScreen';

export default ReportedContentScreen;
